<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ezCrxY/tc-custom/9781504003513.jpg?1705025875960" alt="This image is the cover for the book Monday I Love You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monday I Love You
      </h1>
      <p class="bookDescription body article font2">
        <b>Grace has two big problems—how will she cope?</b><br/><br/> Grace Schmitt is a bit of a dreamer. In her mind, she’s the most popular girl in school, with flowing golden hair and too many friends to count. And let’s not forget all the boys who admire her perfectly proportioned figure. Everything is, in a word, perfect.<br/><br/> Unfortunately, Grace’s life is a bit more complicated than that in reality. Going into tenth grade, her body changes rapidly, leaving her feeling ungainly, awkward, and conspicuous, mostly because of her large bust. It’s become such a problem that she’s begun saving money for breast-reduction surgery. Things come to a head when a circle of cruel classmates, led by Ashley, the <i>actual</i> most popular girl in school, decide to see if Grace’s breasts are real.<br/><br/> On the worst day of her life, it takes a miracle (in the form of Ms. Govoni, the gym teacher) to save Grace from life-altering humiliation. Little does she know, the experience will trigger an astounding series of events that test her character, bolster her self-esteem, and turn her life around.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Constance C. Greene
      </h2>
      
      <p class="authorDescription body article">Constance C. Greene was the author of over twenty highly successful children&rsquo;s and young adult novels, including the ALA Notable Book <I>A Girl Called Al</I>, <I>Al(exandra) the Great</I>, <I>Getting Nowhere</I>, and <I>Beat the Turtle Drum</I>, which is an ALA Notable Book, an IRA-CBC Children&rsquo;s Choice, and the basis for the Emmy Award&ndash;winning after-school special <I>Very Good Friends</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0da3d12f